import { sessionToken, logout } from './auth.js';

// POST /api/pro { action, … } avec la session de la boutique.
export async function pro(action, body = {}) {
  const res = await fetch('/api/pro', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${sessionToken()}` },
    body: JSON.stringify({ ...body, action }),
  });
  const data = await res.json().catch(() => ({}));
  if (res.status === 401 || res.status === 403) {
    logout();
    window.location.replace('/');
  }
  if (!res.ok) throw new Error(data.error || 'Une erreur est survenue, réessayez dans un instant.');
  return data;
}

// Photo réduite à 1600 px côté navigateur (corps de requête limité), en base64 JPEG.
export function reduirePhoto(file, maxDim = 1600, quality = 0.82) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => {
      let { width: w, height: h } = img;
      if (w > maxDim || h > maxDim) { const r = maxDim / Math.max(w, h); w = Math.round(w * r); h = Math.round(h * r); }
      const c = document.createElement('canvas'); c.width = w; c.height = h;
      c.getContext('2d').drawImage(img, 0, 0, w, h);
      URL.revokeObjectURL(img.src);
      resolve(c.toDataURL('image/jpeg', quality).split(',')[1]);
    };
    img.onerror = () => reject(new Error('Photo illisible.'));
    img.src = URL.createObjectURL(file);
  });
}

export const fmtDate = (d) => (d ? new Date(d).toLocaleDateString('fr-FR', { day: 'numeric', month: 'long', year: 'numeric' }) : '');
export const fmtEuro = (n) => new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR', maximumFractionDigits: Number.isInteger(n) ? 0 : 2 }).format(n || 0);
export const taux = (a, b) => (b > 0 ? Math.round((a / b) * 100) : null);
